module.exports = __webpack_public_path__ + "fonts/557f69957a3ca46707fc552debb8d892.txt";